import React, { useRef, useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import "../popupsright.css";
import coinImage from "../../images/coin.png";
import { PageNavContext } from "../../FunctionalPageLogin";

const apiUrl = process.env.REACT_APP_API_URL;

const formatCoins = (value) => Number(value || 0).toLocaleString("ro-RO");
const formatCoinsCompact = (value) => {
  const coins = Number(value || 0);
  if (coins < 1000) return String(coins);
  return `${Math.floor(coins / 1000)}k`;
};

const CoinButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);
  const pageNav = useContext(PageNavContext);
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coinsFromStats, setCoinsFromStats] = useState(0);
  const [coinsEarnedToday, setCoinsEarnedToday] = useState(0);
  const [coinsSpentToday, setCoinsSpentToday] = useState(0);

  const finalBalance = Number(coinsFromStats || 0);
  const coinEntriesToday = Number(coinsEarnedToday || 0);
  const coinExitsToday = Number(coinsSpentToday || 0);
  const previousBalance = Math.max(0, finalBalance - coinEntriesToday + coinExitsToday);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  const handleGoToCurrentLesson = () => {
    closePopup();
    if (pageNav) {
      pageNav("Invata");
      return;
    }
    navigate("/functionalpagelogin");
  };

  useEffect(() => {
    const fetchUserCoins = async () => {
      try {
        const userRes = await fetch(`${apiUrl}/user`, {
          credentials: "include",
        });

        if (!userRes.ok) return;

        const user = await userRes.json();

        if (!user?.user_id) return;

        const statsRes = await fetch(`${apiUrl}/user/${user.user_id}/stats`, {
          credentials: "include",
        });

        if (!statsRes.ok) return;

        const stats = await statsRes.json();
        setCoinsFromStats(Number(stats?.coins ?? 0));

        const missionsRes = await fetch(`${apiUrl}/missions/today`, {
          credentials: "include",
        });

        if (missionsRes.ok) {
          const missions = await missionsRes.json();
          setCoinsEarnedToday(Number(missions?.coins_earned ?? 0));
          setCoinsSpentToday(Number(missions?.coins_spent ?? 0));
        }
      } catch (error) {
        console.error("Eroare la preluarea user_stats:", error);
      }
    };

    fetchUserCoins();
  }, []);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide popup la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        !isVisible ||
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        closePopup();
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="first-main-pagi-coin-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={isOpen ? closePopup : openPopup}
      >
        <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
        <div className="first-main-pagi-stats-number">{formatCoinsCompact(coinsFromStats)}</div>
      </div>

      {isVisible && createPortal(
        <>
          <div
            className={`first-main-pagi-overlay first-main-pagi-coin-overlay ${isOpen ? "open" : ""}`}
            onClick={closePopup}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-coin-popup first-main-pagi-coin-popup-anim ${isOpen ? "open" : ""} ${
              isMobile ? "mobile" : "desktop"
            }`}
          >
            <div className="first-main-pagi-popup-header">
              <div className="orientation-title-popup-main">
                <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
              <p className="distance-coin">Sold monede</p>

              </div>
              
            </div>
            <div className="coin-balance-details">
              <div className="coin-row">
                <span>Sold precedent:</span>
                <span className="coin-amount">{formatCoins(previousBalance)}</span>
              </div>
              <div className="coin-row">
                <span>Intrari monede:</span>
                <span className="coin-amount">{formatCoins(coinEntriesToday)}</span>
              </div>
              <div className="coin-row">
                <span>Iesiri monede:</span>
                <span className="coin-amount">{formatCoins(coinExitsToday)}</span>
              </div>
              <div className="coin-row">
                <span>Sold final:</span>
                <span className="coin-amount">{formatCoins(finalBalance)}</span>
              </div>
            </div>
           
            <div className="first-main-pagi-popup-item-coins" onClick={handleGoToCurrentLesson}>
              <span className="color-button-streak">Castiga monede</span>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default CoinButtonWithDropdown;
